var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardShell',[_c('div',{staticClass:"pv3 bg-near-white"},[_c('h5',{staticClass:"ph3"},[_vm._v("Search Filters")])]),_c('FiltersCore',{staticClass:"ph3",attrs:{"applyImmediately":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }